import React from "react";
import { Box, Typography, Link } from "@mui/material";

const DocumentMessage = ({ message }) => {
  const url = message?.url || (typeof message?.document === "string" ? message.document : message?.document?.url || message?.document?.link);
  const name = message?.name || message?.document?.name || message?.document?.fileName || message?.document?.filename || "Documento";
  if (!url || !String(url).trim()) return null;
  return (
    <Box>
      <Typography>Documento: </Typography>
      <Link href={url} target="_blank" rel="noopener noreferrer">
        {name}
      </Link>
    </Box>
  );
};

export default DocumentMessage;
